import { cn } from "@base/lib/utils";
import type { DailyLogSearchExcerpt as Excerpt } from "../model/dailyLogSearchSchema";

interface DailyLogSearchExcerptProps {
  excerpt: Excerpt;
  /** 검색어가 있으면 PC는 전체 발췌를, 모바일은 3줄을 보여 준다. 발췌가 첫 일치 앞 60자에서 시작하므로 3줄 안에 일치가 들어온다 */
  hasKeyword: boolean;
}

/**
 * 서버가 준 segments를 텍스트 노드와 <mark>로만 렌더한다.
 * HTML로 해석하지 않으므로 본문의 `<script>` 같은 문자열도 글자 그대로 보인다.
 */
export function DailyLogSearchExcerpt({ excerpt, hasKeyword }: DailyLogSearchExcerptProps) {
  if (excerpt.segments.length === 0) {
    return <p className="text-body4 text-gray-500">No description</p>;
  }

  return (
    <p
      className={cn(
        "text-body4 text-gray-700 break-words [overflow-wrap:anywhere] md:max-w-[720px] md:text-body3 md:text-gray-800",
        hasKeyword ? "line-clamp-3 md:line-clamp-none" : "line-clamp-3 md:line-clamp-2",
      )}
    >
      {excerpt.leading_ellipsis && "…"}
      {excerpt.segments.map((segment, index) =>
        segment.matched ? (
          // 같은 문구가 여러 번 나올 수 있고 segments는 순서가 고정된 정적 배열이다.
          // biome-ignore lint/suspicious/noArrayIndexKey: 순서 고정 배열
          <mark key={index} className="bg-yellow-100 text-inherit rounded-2">
            {segment.text}
          </mark>
        ) : (
          // biome-ignore lint/suspicious/noArrayIndexKey: 순서 고정 배열
          <span key={index}>{segment.text}</span>
        ),
      )}
      {excerpt.trailing_ellipsis && "…"}
    </p>
  );
}
